import { observer } from "mobx-react";

import BaseComponent from "@component/BaseComponent";
import TrainingList from "./List";

@observer
export default class Trainings extends BaseComponent<PropsFromRouter> {
  render() {
    return (
      <>
        <TrainingList match={this.props.match} />
      </>
    );
  }
}
